export const getFieldTitle = (fieldRequired, text) => {
  if (!text) return '';
  return fieldRequired ? (
    <>
      {text}
      <span className="required">*</span>
    </>
  ) : (
    text
  );
};
